import main from '@/main'
import { throttle } from 'throttle-debounce'

export default throttle(5000, (error, type) => main.$toasts(error, type))
